import { useEffect, useRef, useState } from 'react';
import { Card } from 'react-bootstrap';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const relatedHomes = [

    {
        images: [
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_9_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/bigphoto/914/12364914_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_9_0.jpg"
        ],
        price: "$409,000",
        details: "4 bd · 2 ba · — sqft",
        address: "6209 N Nagle Ave, Chicago, IL"
    },
    {
        images: [
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_3_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_6_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_9_0.jpg"
        ],
        price: "$385,000",
        details: "4 bd · 2 ba · 1.8k sqft",
        address: "738 Augusta Ave, Elgin, IL"
    },
    {
        images: [
            "https://ssl.cdn-redfin.com/photo/68/bigphoto/914/12364914_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_3_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_9_0.jpg"
        ],
        price: "$435,000",
        details: "4 bd · 3 ba · 1.8k sqft",
        address: "6331 W Cornelia Ave, Chicago, IL"
    },
    {
        images: [
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_3_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_6_0.jpg",
            "https://ssl.cdn-redfin.com/photo/68/mbphotov3/914/genMid.12364914_9_0.jpg"
        ],
        price: "$385,000",
        details: "4 bd · 2 ba · 1.8k sqft",
        address: "738 Augusta Ave, Elgin, IL"
    },
];


export default function NearbyListings() {
    const containerRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [imageIndexes, setImageIndexes] = useState({});

    const updateScrollButtons = () => {
        const el = containerRef.current;
        if (!el) return;
        setCanScrollLeft(el.scrollLeft > 0);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth);
    };

    const scroll = (direction) => {
        const el = containerRef.current;
        if (!el) return;
        const offset = direction === "left" ? -300 : 300;
        el.scrollBy({ left: offset, behavior: "smooth" });
    };

    const handleNextImage = (idx, total) => {
        setImageIndexes(prev => ({
            ...prev,
            [idx]: ((prev[idx] ?? 0) + 1) % total
        }));
    };

    const handlePrevImage = (idx, total) => {
        setImageIndexes(prev => ({
            ...prev,
            [idx]: ((prev[idx] ?? 0) - 1 + total) % total
        }));
    };

    useEffect(() => {
        updateScrollButtons();
        const el = containerRef.current;
        if (!el) return;

        el.addEventListener("scroll", updateScrollButtons);
        window.addEventListener("resize", updateScrollButtons);

        return () => {
            el.removeEventListener("scroll", updateScrollButtons);
            window.removeEventListener("resize", updateScrollButtons);
        };
    }, []);

    return (
        <div style={{ position: 'relative' }}>
            <h3 style={{ marginBottom: '0.75rem' }}>Nearby Listings</h3>

            {canScrollLeft && (
                <ChevronLeftIcon
                    onClick={() => scroll("left")}
                    style={{
                        position: 'absolute',
                        left: 0,
                        top: '45%',
                        zIndex: 1,
                        backgroundColor: '#fff',
                        borderRadius: '50%',
                        boxShadow: '0 0 6px rgba(0,0,0,0.1)',
                        cursor: 'pointer',
                        fontSize: '2rem'
                    }}
                />
            )}
            <div
                ref={containerRef}
                style={{
                    display: 'flex',
                    overflowX: 'auto',
                    gap: '1rem',
                    scrollBehavior: 'smooth',
                    scrollbarWidth: 'none', // Firefox
                    msOverflowStyle: 'none', // IE/Edge
                    WebkitOverflowScrolling: 'touch', // Smooth scrolling for iOS
                }}
                // Inline style to hide scrollbar for WebKit browsers
                onScroll={(e) => {
                    e.currentTarget.style.scrollbarWidth = 'none';
                }}
            >
                <style>
                    {`
        div::-webkit-scrollbar {
            display: none;
        }
    `}
                </style>
                {relatedHomes.map((home, idx) => {
                    const currentImageIndex = imageIndexes[idx] ?? 0;
                    const totalImages = home.images.length;
                    return (
                        <Card
                            key={idx}
                            style={{ minWidth: '240px', flex: '0 0 auto', borderRadius: '0.75rem', overflow: 'hidden', position: 'relative' }}
                            onMouseEnter={() => setHoveredIndex(idx)}
                            onMouseLeave={() => setHoveredIndex(null)}
                            className='shadow-sm'
                        >
                            <div style={{ position: 'relative' }}>
                                <Card.Img src={home.images[currentImageIndex]} style={{ height: '160px', objectFit: 'cover' }} />
                                {hoveredIndex === idx && totalImages > 1 && (
                                    <>
                                        <ChevronLeftIcon
                                            onClick={() => handlePrevImage(idx, totalImages)}
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                left: 8,
                                                transform: 'translateY(-50%)',
                                                backgroundColor: '#fff',
                                                borderRadius: '50%',
                                                boxShadow: '0 0 4px rgba(0,0,0,0.2)',
                                                cursor: 'pointer',
                                                fontSize: '1.5rem',
                                                zIndex: 1
                                            }}
                                        />
                                        <ChevronRightIcon
                                            onClick={() => handleNextImage(idx, totalImages)}
                                            style={{
                                                position: 'absolute',
                                                top: '50%',
                                                right: 8,
                                                transform: 'translateY(-50%)',
                                                backgroundColor: '#fff',
                                                borderRadius: '50%',
                                                boxShadow: '0 0 4px rgba(0,0,0,0.2)',
                                                cursor: 'pointer',
                                                fontSize: '1.5rem',
                                                zIndex: 1
                                            }}
                                        />
                                    </>
                                )}
                            </div>
                            <Card.Body style={{ padding: '0.75rem' }}>
                                <div style={{ fontSize: '1rem', fontWeight: '600' }}>{home.price}</div>
                                <div style={{ fontSize: '0.85rem', color: '#555' }}>{home.details}</div>
                                <div style={{ fontSize: '0.8rem', color: '#777' }}>{home.address}</div>
                            </Card.Body>
                        </Card>
                    );
                })}
            </div>
            {canScrollRight && (
                <ChevronRightIcon
                    onClick={() => scroll("right")}
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '45%',
                        zIndex: 1,
                        backgroundColor: '#fff',
                        borderRadius: '50%',
                        boxShadow: '0 0 6px rgba(0,0,0,0.1)',
                        cursor: 'pointer',
                        fontSize: '2rem'
                    }}
                />
            )}
        </div>
    );
}